// management-frontend/src/components/ChangePassword.js

import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const { changePassword, user } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.initialPassword) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      alert("Preencha todos os campos");
      return;
    }

    if (password !== confirmPassword) {
      alert("As senhas não conferem");
      return;
    }

    try {
      const success = await changePassword(user.id, password);

      if (success) {
        alert("Senha alterada com sucesso");
        navigate("/");
      } else {
        alert("Erro ao alterar a senha");
      }
    } catch (err) {
      alert("Erro ao alterar a senha");
    }
  };

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
      <form className="p-4 border rounded shadow bg-light" style={{ width: "400px" }}>
        <h5 className="mb-3 text-center">Definir nova senha</h5>

        <div className="form-group mb-2">
          <input type="password" className="form-control" placeholder="Nova senha" onChange={(e) => setPassword(e.target.value)} />
        </div>

        <div className="form-group mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="Confirmar nova senha"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <button className="btn btn-primary w-100" onClick={handleSave}>
          Salvar nova senha
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
